/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_UptimeInputs */

const en_measure_uptime = /** @type {(inputs: Measure_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uptime`)
};

const zh_hans1_measure_uptime = /** @type {(inputs: Measure_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用率`)
};

const pt_br2_measure_uptime = /** @type {(inputs: Measure_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilidade`)
};

const es_measure_uptime = /** @type {(inputs: Measure_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilidad`)
};

const fr_measure_uptime = /** @type {(inputs: Measure_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilité`)
};

const de_measure_uptime = /** @type {(inputs: Measure_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbarkeit`)
};

const ru_measure_uptime = /** @type {(inputs: Measure_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступность`)
};

const it_measure_uptime = /** @type {(inputs: Measure_UptimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilità`)
};

/**
* | output |
* | --- |
* | "Uptime" |
*
* @param {Measure_UptimeInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_uptime = /** @type {((inputs?: Measure_UptimeInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_UptimeInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_uptime(inputs)
	if (locale === "pt-BR") return pt_br2_measure_uptime(inputs)
	if (locale === "es") return es_measure_uptime(inputs)
	if (locale === "fr") return fr_measure_uptime(inputs)
	if (locale === "de") return de_measure_uptime(inputs)
	if (locale === "ru") return ru_measure_uptime(inputs)
	if (locale === "it") return it_measure_uptime(inputs)
	return en_measure_uptime(inputs)
});